export default {
  likes: { name: 'me gusta' },
  shares: { name: 'compartidos' },
  comments: { name: 'comentarios' },
  videoplays: { name: 'reproducciones de video' },
  followers: { name: 'seguidores' },
  unknown: { name: 'desconocido' },
};
